import { Session } from '@/types/session.types';
import { Get } from '../helpers';

export const GetSession = (sessionId: number): Promise<Session> => {
  return Get({
    path: `/v3/admin/events/session/${sessionId}`,
  });
};
